import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChatPage } from './app-chat';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChatPage,
  ],
  imports: [
    IonicPageModule.forChild(AppChatPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppChatPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-chat/app-chat.module.ts